module.exports = __webpack_public_path__ + "static/media/circle_03.227aa169.svg";